import React from 'react';
import { Card } from 'react-bootstrap';
import { Line } from 'react-chartjs-2';
import { chartJsDefaultTooltip } from './chartjs-utils';
import PropTypes from 'prop-types';
import chartTrendline from 'chartjs-plugin-trendline';
import { Chart as ChartJS } from 'chart.js';

ChartJS.register(chartTrendline);

export const SingleLineChart = ({
  title,
  labels,
  dataset,
  borderColor,
  borderWidth,
  width,
  height,
  legendLabel
}) => {
  const data = {
    labels,
    datasets: [
      {
        label: legendLabel,
        borderColor: borderColor,
        borderWidth: borderWidth,
        backgroundColor: '#0275d8',
        data: dataset,
        trendlineLinear: {
          colorMin: 'rgba(255,26,104, 0.5)',
          colorMax: 'rgba(255,26,104, 0.5)',
          lineStyle: 'dashed',
          width: 2,
          projection: true,
          label: {
            color: 'rgba(255,26,104, 1)',
            text: 'Trend Line',
            display: false,
            displayValue: true,
            percentage: true
          },
          legend: {
            text: 'Trend Line',
            borderColor: 'rgba(255,26,104, 1)',
            strokeStyle: 'rgba(255,26,104, 1)',
            fillStyle: 'rgba(255,26,104, 1)',
            lineCap: 'Trend'
          }
        }
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: chartJsDefaultTooltip(borderColor)
    }
  };

  return (
    <Card style={{ width: width, height: height }}>
      <Card.Header>
        <h4 style={{ textAlign: 'center' }}>{title}</h4>
      </Card.Header>
      <Card.Body>
        <Line data={data} options={options} height={'100%'} width={'100%'} />
      </Card.Body>
    </Card>
  );
};

SingleLineChart.propTypes = {
  title: PropTypes.string,
  labels: PropTypes.array,
  dataset: PropTypes.array,
  width: PropTypes.number,
  height: PropTypes.number,
  borderColor: PropTypes.string,
  borderWidth: PropTypes.number,
  legendLabel: PropTypes.string
};
